
/**
 * 请求载入并执行一个 JavaScript 文件
 *
 * @method getScript
 * @param {String} url js文件的url
 * @param {Function} [callback] 成功回调函数
 * @return {void} 无返回
 */
export default function getScript(url, resolve, reject) {
  const script = document.createElement('script');
  script.async = 'async';
  script.src = url;
  script.onload = resolve || (() => {});
  script.onerror = reject || (() => { console.error('load js err:', url) });
  document.getElementsByTagName('head')[0].appendChild(script);
}

export function initScripts(...args) {
  const getPromise = []
  for (const url of args) {
    getPromise.push(new Promise((resolve, reject) => {
      getScript(url, resolve, reject);
    }))
  }

  return Promise.all(getPromise);
}
